<p class="p-3" *ngIf="isSettingsOverview()">
    <app-settings-widget *permissions="Permission.SMP_SETTINGS"></app-settings-widget>
</p>
<router-outlet></router-outlet>